import { PropsWithChildren, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useAuth } from "./AuthProvider";

export function SignIn({children}: PropsWithChildren<{}>): JSX.Element {
  const location = useLocation();
  const state = location.state as { returnUrl: string };
  
  const { service } = useAuth();

  useEffect(() => {
    const returnUrl = state?.returnUrl || location.pathname + location.search + location.hash
    service.startSignIn(returnUrl)
  }, [location, service, state?.returnUrl]);

  return (
    <>{children}</>
  );
}